var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"minilinechart-page"},[_c('div',{staticClass:"minilinechart-container",attrs:{"id":_vm.minilineid}})])}
var staticRenderFns = []

export { render, staticRenderFns }